import { render } from "./EditClientModal.vue?vue&type=template&id=1a7a48a2&scoped=true"
import script from "./EditClientModal.vue?vue&type=script&lang=js"
export * from "./EditClientModal.vue?vue&type=script&lang=js"

import "./EditClientModal.vue?vue&type=style&index=0&id=1a7a48a2&lang=stylus&scoped=true"
import "./EditClientModal.vue?vue&type=style&index=1&id=1a7a48a2&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7a48a2"]])

export default __exports__